export default "__VITE_ASSET__364a921f__"